import classnames from 'classnames';
import React, { useCallback } from 'react';
import { IoIosCheckmark as TickIcon } from 'react-icons/io';
import { createUseStyles } from 'react-jss';
import { useDispatch, useSelector } from 'react-redux';

import { ZINDEX } from '../../constants';
import { toggleFilter } from '../../redux/actions';

const useStyles = createUseStyles({
  button: {
    '&.hidden': { background: '#272727', color: '#393939' },
    '&.hidden:hover': { background: '#FFAE49', color: '#FFFFFF' },
    '&:hover': { background: '#272727', color: '#393939' },
    background: '#FFAE49',
    borderRadius: 24,
    bottom: 12,
    boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.45)',
    color: '#FFFFFF',
    composes: ['is-block', 'is-absolute', 'no-overflow'],
    height: 48,
    left: 12,
    transition: 'color 0.3s, background 0.3s',
    width: 48,
    zIndex: ZINDEX.MAP_CONTROLS,
  },
  icon: {
    verticalAlign: 'middle',
  },
});

const CompletedButtonComponent = React.memo(() => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const filters = useSelector(_ => _.filters);
  const hidden = filters.includes('completed');

  const clickHandler = useCallback(
    (types, visible) => dispatch(toggleFilter(types, visible)),
    [dispatch]
  );

  return (
    <button
      className={classnames(classes.button, { hidden })}
      type="button"
      onClick={() => clickHandler(['completed'], !hidden)}>
      <TickIcon className={classes.icon} size={42} />
    </button>
  );
});

CompletedButtonComponent.displayName = 'CompletedButtonComponent';

export default CompletedButtonComponent;
